import isToHttps from '@lib/isToHttps.js';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import particles from 'particles.js';
Vue.use(particles);
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';
Vue.use(VueAreaLinkage);
import GlobalConfig from './lib/config';
import method from './lib/method';
import extend from '@lib/extend.js';
import './assets/common/common.css';
import VueJsonp from 'vue-jsonp';
import('@/assets/styles/index.scss');
require('@/assets/icon/iconfont.css');
import VueBus from 'vue-bus';
Vue.use(VueBus);
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'pFf2pta7P4d4uBm6bCcdSWxrQkcGIn0v',
});
import { Base64 } from 'js-base64';
import moment from 'vue-moment';
Vue.use(VueJsonp);
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.component(CollapseTransition.name, CollapseTransition)
// 按需引入
import {
  Button,
  Pagination,
  Carousel,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  RadioGroup,
  RadioButton,
  Tooltip,
  Table,
  TableColumn,
  CarouselItem,
  Tabs,
  TabPane,
  Select,
  Option,
  Dialog,
  Icon,
  DatePicker,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Radio,
  Form,
  FormItem,
  Upload,
  Checkbox,
  Message,
  CheckboxGroup,
  Loading,
  MessageBox,
  Scrollbar,
  Drawer,
  Popover,
  Divider,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import errorHandler from '@lib/errorHandler.js';
import saveLog from '@lib/saveLog.js';
Vue.use(saveLog);
Vue.use(errorHandler, Vue);
// 按需引入
Vue.use(Scrollbar);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Submenu);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Tooltip);
Vue.use(Icon);
Vue.use(moment);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Input);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Radio);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Loading);
Vue.use(Loading.directive);
Vue.use(Drawer);
Vue.use(Popover);
Vue.use(Divider);
Vue.prototype.$Ajax = axios;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$Moment = moment;
Vue.prototype.$Method = method;
Vue.prototype.$message = Message;
Vue.prototype.$GlobalConfig = GlobalConfig;
Vue.prototype.$confirm = MessageBox.confirm;
// function getHtmlFontSize() {
//   document.documentElement.style.fontSize =
//     document.body.clientWidth /7.5 + "px" || "19.2px";
// }
// getHtmlFontSize();
// window.addEventListener("resize", getHtmlFontSize);
new Vue({
  router,
  store,
  render: function (createElement) {
    // if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
    window.addEventListener(
      'hashchange',
      () => {
        var currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false,
    );
    // }
    return createElement(App);
  },
}).$mount('#app');
